export const shadows = {
  xs: '0 1px 2px 0 rgba(0, 0, 0, 0.04)',
  sm: '0 1px 2px 0 rgba(0, 0, 0, 0.04), 0 1px 3px 0 rgba(0, 0, 0, 0.12)',
  md: '0 2px 4px -1px rgba(0, 0, 0, 0.04), 0 3px 6px -1px rgba(0, 0, 0, 0.12)',
  lg: '0 3px 6px -2px rgba(20, 21, 26, 0.05), 0 10px 16px -3px rgba(0, 0, 0, 0.12)',
  xl: '0 8px 8px -5px rgba(0, 0, 0, 0.08), 0 18px 24px -5px rgba(0, 0, 0, 0.12)',
};
